import React, {Fragment, useEffect, useState} from "react";
import Pager from "./Pager";
import Translate from "../Translate";
import NsRowTabellaDesktop from "./NsRowTabellaDesktop";
import {formattaInteroConCommas} from "../../utility/common";
import NsInputFiltroTabella from "./NsInputFiltroTabella";


function NsTabellaDesktop({
                              data,
                              conditionalRowStyles,
                              additionalClasses,
                              onRowClicked,
                              onRowDbClick,
                              columns,
                              funzioneFiltro,
                              componenteFiltro,
                              paginaCorrente = 1,
                              totalePagine = 0,
                              handlerCambioPagina,
                              addFiltri,
                              addDetail,
                              getDettaglio,
                              orderBy,
                              orderByColonna = '',
                              orderByDirezione = '',
                              totRighe,
                              recordPerPagina
                          }) {

    const [mappaColOrdinamento, setMappaColOrdinamento] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [filteredItems, setFilteredItems] = useState([]);
    const [pagina, setPagina] = useState(paginaCorrente);
    const [totPagine, setTotPagine] = useState(totalePagine);
    const [filtriHeaderClient, setFiltriHeaderClient] = useState({});

    function getMappaOrdinamento(colonnaOrdineSel) {
        let mapOrd = [];

        columns.forEach((colonna, idx) => {
            if (colonna.sortable && colonna.sortable === true) {
                mapOrd[idx] = 'init';

                if (orderByColonna !== '' && orderByDirezione !== '' && colonna.dbcol && colonna.dbcol === colonnaOrdineSel) {
                    mapOrd[idx] = orderByDirezione;
                }
            }
        });

        return mapOrd;
    }

    useEffect(() => {
        /*
        =============================================
        === Gestione filtro con campo di ricerca
        =============================================
         */
        let valFiltrati = data ? data.filter(
            item => funzioneFiltro ? funzioneFiltro(item, filterText) : true
        ) : [];

        /*
        =============================================
        === Gestione filtro header lato client
        =============================================
         */
        Object.keys(filtriHeaderClient).forEach((nomeColFiltro) => {
            let valFiltro = filtriHeaderClient[nomeColFiltro];
            if (valFiltro === 0 || (valFiltro && valFiltro !== '')) {
                let colFiltro = columns.filter((col) => col.name === nomeColFiltro);
                if (colFiltro && colFiltro.length > 0 && colFiltro[0].filtroHeader?.filterFunction) {
                    valFiltrati = valFiltrati.filter(item => colFiltro[0].filtroHeader.filterFunction(item, valFiltro));
                }
            } else {
                // rimuovo il filtro per mantenere corretta il totale lato client senza filtri
                // senza rimozione rimarrebbe sempre un filtro vuoto: le opzioni filtrate sono tutte, ma paginate, quindi il totale risulterebbe errato
                delete filtriHeaderClient[nomeColFiltro];
            }
        })


        /*
        =============================================
        === Gestione sort colonne
        =============================================
         */
        let mapOrd = getMappaOrdinamento(orderByColonna);
        setMappaColOrdinamento(mapOrd);

        if (!handlerCambioPagina) {
            // Totale pagine (massimo record per pagina = 10)
            setTotPagine(Math.ceil(valFiltrati.length / recordPerPagina))

            // Suddivido (ulteriormente) i valori filtrati in base alla pagina
            var start = (pagina - 1) * recordPerPagina
            var end = start + recordPerPagina
            end = valFiltrati.length > end ? end : valFiltrati.length

            var valoriPaginati = []
            for (let i = start; i < end; i++) {
                valoriPaginati.push(valFiltrati[i])
            }

            valFiltrati = valoriPaginati
        }

        setFilteredItems(valFiltrati)
    }, [data, filterText, filtriHeaderClient, pagina]);

    useEffect(() => {
        setPagina(paginaCorrente);
    }, [paginaCorrente]);

    useEffect(() => {
        if (totalePagine && totalePagine !== '') {
            setTotPagine(totalePagine)
        }
    }, [totalePagine]);

    const sortFun = (rowA, rowB, idx) => {
        let a = columns[idx].selector(rowA);
        let b = columns[idx].selector(rowB);

        if (isNaN(a)) {
            a = a.toLowerCase()
        }
        if (isNaN(b)) {
            b = b.toLowerCase()
        }

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0
    }

    const sortDati = (idx, ord, sortFunction) => {
        if (ord === 'up') {
            if (sortFunction) {
                filteredItems.sort((a, b) => {
                    return sortFunction(a, b)
                })
            } else {
                filteredItems.sort((a, b) => {
                    return sortFun(a, b, idx)
                })
            }
        } else if (ord === 'down') {
            if (sortFunction) {
                filteredItems.sort((a, b) => {
                    return sortFunction(b, a)
                })
            } else {
                filteredItems.sort((a, b) => {
                    return sortFun(b, a, idx)
                })
            }
        }
    }

    const cambioPagina = (nuovaPagina) => {
        setPagina(nuovaPagina)
    }

    function getSortIcon(idx) {
        if (mappaColOrdinamento[idx] === 'up') {
            return (
                <i className="fas fa-sort-amount-down-alt"/>
            );
        } else if (mappaColOrdinamento[idx] === 'down') {
            return (
                <i className="fas fa-sort-amount-up"/>
            );
        } else {
            return (
                <i className="fas fa-sort"/>
            );
        }
    }

    return (
        <Fragment>
            {
                addFiltri === true &&
                <div className={'row'}>
                    <div className={'col-md-12 text-end'}>
                        {
                            componenteFiltro ?
                                <div className={'mb-2'}>
                                    {
                                        componenteFiltro()
                                    }
                                </div>
                                : <Fragment>
                                    <input
                                        id="ricerca"
                                        name="ricerca"
                                        type="text"
                                        placeholder="Cerca"
                                        aria-label="Cerca"
                                        value={filterText}
                                        onChange={e => {
                                            setPagina(1)
                                            setFilterText(e.target.value)
                                        }}
                                        className={"ns-filtro-data-table mb-2"}
                                        autoComplete="off"
                                    />
                                </Fragment>
                        }
                    </div>
                </div>
            }
            <div className="table-responsive ns-overflow-auto">
                <table className="table table-sm table-hover ns-table-desktop">
                    <thead className="ns-table-head">
                    <tr>
                        {
                            addDetail === true ? <th></th> : ''
                        }
                        {
                            columns.filter(colonna => !colonna.visible || colonna.visible() === true).map((colonna, idx) => {
                                return (
                                    <th
                                        key={idx}
                                        className={"ns-table-th"}
                                    >
                                        <span
                                            onClick={() => {
                                                if (mappaColOrdinamento[idx]) {
                                                    let mapOrd = getMappaOrdinamento(colonna.dbcol);
                                                    if (mappaColOrdinamento[idx] === 'init') {
                                                        mapOrd[idx] = 'up';
                                                    } else {
                                                        mapOrd[idx] = mappaColOrdinamento[idx] === 'up' ? 'down' : 'up';
                                                    }
                                                    setMappaColOrdinamento(mapOrd);

                                                    if (orderBy) {
                                                        orderBy(colonna.dbcol, mapOrd[idx])
                                                    } else {
                                                        sortDati(idx, mapOrd[idx], colonna.sortFunction)
                                                    }
                                                }
                                            }}
                                        >
                                        {colonna.name}
                                            {
                                                colonna.sortable && colonna.sortable === true &&
                                                <span className="ns-sort-colonna-img ms-1">
                                                {
                                                    getSortIcon(idx)
                                                }
                                                </span>
                                            }
                                        </span>
                                    </th>
                                )
                            })
                        }
                    </tr>
                    {
                        columns.filter(colonna => colonna.filtroHeader).length > 0 &&
                        <tr className={"ns-table-tr-filtro"}>
                            {
                                addDetail === true ? <th></th> : ''
                            }
                            {
                                columns.filter(colonna => !colonna.visible || colonna.visible() === true).map((colonna, idx) => {
                                    return (
                                        <th
                                            key={'2_' + idx}
                                            className={"ns-table-th"}
                                            style={colonna.style}
                                        >
                                            {
                                                colonna.filtroHeader &&
                                                <NsInputFiltroTabella
                                                    filtro={colonna.filtroHeader}
                                                    filter={(val) => {
                                                        // Filtro lato client a meno che non sia stato impostato l'attributo lazy a true
                                                        if (!colonna.filtroHeader.lazy || colonna.filtroHeader.lazy === false) {
                                                            setFiltriHeaderClient(prevState => ({
                                                                ...prevState, [colonna.name]: val
                                                            }));
                                                        }
                                                    }}
                                                />
                                            }
                                        </th>
                                    )
                                })
                            }
                        </tr>
                    }
                    </thead>
                    <tbody>
                    {
                        filteredItems.length === 0 ?
                            <tr>
                                <td colSpan={columns.length + (addDetail === true ? 1 : 0)} className={'text-center'}>
                                    <Translate>Nessun dato presente</Translate>
                                </td>
                            </tr>
                            : (
                                filteredItems.map((el, idx) => {
                                    var classiAggiuntive = ''

                                    // Controllo se ci sono classi da aggiungere
                                    if (additionalClasses) {
                                        additionalClasses.forEach((condizione) => {
                                            if (condizione.when(el)) {
                                                classiAggiuntive = condizione.classNames;
                                            }
                                        })
                                    }

                                    let style = {};
                                    if (conditionalRowStyles) {
                                        style = conditionalRowStyles(el);
                                    }

                                    return <NsRowTabellaDesktop
                                        key={idx}
                                        el={el}
                                        style={style}
                                        addDetail={addDetail}
                                        classiAggiuntive={classiAggiuntive}
                                        columns={columns}
                                        onRowClicked={onRowClicked}
                                        onRowDbClick={onRowDbClick}
                                        getDettaglio={getDettaglio}
                                    />
                                })
                            )
                    }
                    </tbody>
                </table>
            </div>
            <div className={"row"}>
                <div className={"col-md-6"}>
                    <Translate>Numero di risultati elencati: </Translate>
                    <strong>{formattaInteroConCommas(((filterText && filterText !== '') || Object.keys(filtriHeaderClient).length > 0) ? filteredItems.length : (totRighe || (data && data.length)))}</strong>
                </div>
                <div className={"col-md-6"}>
                    <Pager
                        pagina={pagina}
                        totale={totPagine}
                        handlerCambioPagina={handlerCambioPagina ? handlerCambioPagina : cambioPagina}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default NsTabellaDesktop;